import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';
import UI from '../../ui';
import Utils from '../../utils';
import ResetFieldsModal from './ResetFieldsModal.component';
import Util from '../Util';

const { WrappedButton, WrappedButtonType, WrappedCheckbox } = UI;
const { Session, withLayoutAndModalContexts } = Utils;

class GeneralView extends Component {
	constructor(props) {
		super(props);

		const {
			SkipPrintConfirm = '0',
			isAllowEnvelopeGif = '0',
			SaveToAddressBook = '0',
			ResetFieldService = '0',
			ResetFieldWeight = '0',
			ResetFieldDimensions = '0',
			ResetFieldMailToAddress = '0',
			ResetFieldTracking = '0',
			ResetFieldExtraServices = '0',
			ResetFieldInsurance = '0',
			ResetFieldReferenceNumbers = '0',
			ResetFieldCostCode = '0',
			ResetFieldCustoms = '0',
			ResetFieldQuantity = '0',
			ResetFieldStampAmout = '0',
			AutoAdvanceLabel = '0',
		} = Session.getPreferences();

		this.state = {
			skipPrintConfirm: SkipPrintConfirm !== '0',
			isAllowEnvelopeGif: isAllowEnvelopeGif !== '0',
			saveToAddressBook: SaveToAddressBook !== '0',
			resetFieldService: ResetFieldService,
			resetFieldWeight: ResetFieldWeight,
			resetFieldDimensions: ResetFieldDimensions,
			resetFieldMailToAddress: ResetFieldMailToAddress,
			resetFieldTracking: ResetFieldTracking,
			resetFieldExtraServices: ResetFieldExtraServices,
			resetFieldInsurance: ResetFieldInsurance,
			resetFieldReferenceNumbers: ResetFieldReferenceNumbers,
			resetFieldCostCode: ResetFieldCostCode,
			resetFieldCustoms: ResetFieldCustoms,
			resetFieldQuantity: ResetFieldQuantity,
			resetFieldStampAmout: ResetFieldStampAmout,
			autoAdvanceLabel: AutoAdvanceLabel,
		};
	}

	onChangeCheckbox = ({ target: { name } }) => {
		const { [name]: value } = this.state;
		const { showError } = this.context;

		this.setState(prevState => ({ [name]: !prevState[name] }));

		Util.saveNewPreferences(
			{ [name]: value === '0' || value === false ? '1' : '0' },
			showError
		);
	};

	onClickSelect = () => {
		const {
			resetFieldService,
			resetFieldWeight,
			resetFieldDimensions,
			resetFieldMailToAddress,
			resetFieldTracking,
			resetFieldExtraServices,
			resetFieldInsurance,
			resetFieldReferenceNumbers,
			resetFieldCostCode,
			resetFieldCustoms,
			resetFieldQuantity,
			resetFieldStampAmout,
			autoAdvanceLabel,
		} = this.state;
		const {
			modalContext: { showModal },
		} = this.props;

		showModal({
			component: ResetFieldsModal,
			data: {
				preferences: {
					resetFieldService,
					resetFieldWeight,
					resetFieldDimensions,
					resetFieldMailToAddress,
					resetFieldTracking,
					resetFieldExtraServices,
					resetFieldInsurance,
					resetFieldReferenceNumbers,
					resetFieldCostCode,
					resetFieldCustoms,
					resetFieldQuantity,
					resetFieldStampAmout,
					autoAdvanceLabel,
				},
				closeCallback: this.onCloseResetFieldModal,
			},
		});
	};

	onClickDone = () => {
		const { completionCallback } = this.props;

		if (isFunction(completionCallback)) {
			completionCallback({ close: true });
		}
	};

	/**
	 * Merge the changes done in ResetFieldModal
	 * @param {object} newPreferences new prefernces from reset field modal
	 */
	onCloseResetFieldModal = newPreferences => {
		if (!isEmpty(newPreferences)) {
			this.setState({
				...newPreferences,
			});
		}
	};

	render() {
		const { skipPrintConfirm, isAllowEnvelopeGif, saveToAddressBook } = this.state;
		const {
			layoutContext: { isMobile },
		} = this.props;

		const mobileCls = isMobile ? 'mobile-view' : '';

		return (
			<div className="settings-mail-general-view">
				<div className="settings-body">
					<div className="settings-content-header">
						<p>General Settings</p>
						<hr />
					</div>
					<div className="p-grid p-dir-col">
						<div className={`p-col-12 print-options-container ${mobileCls}`}>
							<div
								className={`settings-label ${mobileCls}`}
								data-qa="settingsMailGeneral-printOptions-label"
								{...{ dataqa: 'settingsMailGeneral-printOptions-label' }}
							>
								Print Options:
							</div>
							<div className="p-dir-col">
								<WrappedCheckbox
									inputId="settings-skip-print-confirm"
									name="skipPrintConfirm"
									onChange={this.onChangeCheckbox}
									checked={skipPrintConfirm}
									dataqa="settingsMailGeneral-dontshowconfdialog"
								>
									Don't show print confirmation dialog
								</WrappedCheckbox>
								<WrappedCheckbox
									inputId="settings-allow-envelope-gif"
									name="isAllowEnvelopeGif"
									onChange={this.onChangeCheckbox}
									checked={isAllowEnvelopeGif}
									dataqa="settingsMailGeneral-allowprintingonenvelopes"
								>
									Allow printing on envelopes without Stamps.com Connect (requires
									Chrome browser)
								</WrappedCheckbox>
							</div>
						</div>
						<div className={`p-col-12 ${mobileCls}`}>
							<div
								className={`settings-label ${mobileCls}`}
								data-qa="settingsMailGeneral-resetfields-wrapper"
								{...{ dataqa: 'settingsMailGeneral-resetfields-wrapper' }}
							>
								Reset Fields:
							</div>
							<div className="settings-reset-fields">
								<WrappedButton
									buttonType={WrappedButtonType.Secondary}
									label="Select..."
									onClick={this.onClickSelect}
									dataqa="settingsMailGeneral-resetFields"
								/>
								<span>
									Check which fields to reset after each print (does not apply to
									Orders)
								</span>
							</div>
						</div>
						<div className={`p-col-12 ${mobileCls}`}>
							<div className={`settings-label ${mobileCls}`}>Contacts:</div>
							<WrappedCheckbox
								inputId="settings-save-to-addressbook"
								className="inline-item"
								name="saveToAddressBook"
								onChange={this.onChangeCheckbox}
								checked={saveToAddressBook}
								dataqa="settingsMailGeneral-autosavecontacts"
							>
								Automatically save manually entered delivery delivery addresses
								(does not apply to Orders)
							</WrappedCheckbox>
						</div>
					</div>
				</div>
				<div className="settings-content-footer">
					<WrappedButton
						className="settings-button"
						label="Done"
						type="button"
						onClick={this.onClickDone}
						dataqa="settingsMailGeneral-done"
					/>
				</div>
			</div>
		);
	}
}

export default withLayoutAndModalContexts(GeneralView);
